import { useCallback, useEffect, useRef } from "react";

const useIdleTimer = (
  unlockField: (fieldId: string) => void,
  currentlyEditingField: string | null,
) => {
  const idleTimerRef = useRef<NodeJS.Timeout | null>(null);
  const IDLE_TIMEOUT = 5 * 60 * 1000; // 5 minutes

  const resetIdleTimer = useCallback(() => {
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current);
    }

    if (currentlyEditingField) {
      idleTimerRef.current = setTimeout(() => {
        unlockField(currentlyEditingField);
      }, IDLE_TIMEOUT);
    }
  }, [currentlyEditingField, unlockField]);

  // Set up global activity listeners
  useEffect(() => {
    const events = ["keydown", "mousemove", "click", "scroll"];

    events.forEach((event) => {
      document.addEventListener(event, resetIdleTimer, { passive: true });
    });

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, resetIdleTimer);
      });
      if (idleTimerRef.current) {
        clearTimeout(idleTimerRef.current);
      }
    };
  }, [resetIdleTimer]);

  return { resetIdleTimer };
};

export default useIdleTimer;
